// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  padding: 60px 20px 20px;
  margin-top: 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-logo {
  margin-bottom: 20px;
  cursor: pointer;
  filter: brightness(0) invert(1);
}

.footer-tagline {
  font-size: 1rem;
  color: #ccc;
  margin-bottom: 20px;
  line-height: 1.6;
}

.footer-copyright {
  font-size: 0.9rem;
  color: #999;
}

.footer-heading {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: white;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  padding: 8px 0;
  color: #ccc;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.footer-links li:hover {
  color: #ba7a27;
  padding-left: 5px;
}

.footer-text {
  font-size: 1rem;
  color: #ccc;
  margin-bottom: 20px;
  line-height: 1.6;
}

.footer-cta {
  padding: 14px 30px;
  font-size: 1rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
}

.footer-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(186, 122, 39, 0.4);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
}

.footer-bottom p {
  color: #999;
  font-size: 0.9rem;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .footer {
    padding: 40px 15px 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-section {
    text-align: center;
    align-items: center;
  }

  .footer-links li {
    text-align: center;
  }

  .footer-links li:hover {
    padding-left: 0;
  }

  .footer-cta {
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  color: white;\n  padding: 60px 20px 20px;\n  margin-top: 0;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 40px;\n  margin-bottom: 40px;\n}\n\n.footer-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-logo {\n  margin-bottom: 20px;\n  cursor: pointer;\n  filter: brightness(0) invert(1);\n}\n\n.footer-tagline {\n  font-size: 1rem;\n  color: #ccc;\n  margin-bottom: 20px;\n  line-height: 1.6;\n}\n\n.footer-copyright {\n  font-size: 0.9rem;\n  color: #999;\n}\n\n.footer-heading {\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.footer-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-links li {\n  padding: 8px 0;\n  color: #ccc;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.footer-links li:hover {\n  color: #ba7a27;\n  padding-left: 5px;\n}\n\n.footer-text {\n  font-size: 1rem;\n  color: #ccc;\n  margin-bottom: 20px;\n  line-height: 1.6;\n}\n\n.footer-cta {\n  padding: 14px 30px;\n  font-size: 1rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #ba7a27 0%, #d6792c 100%);\n  color: white;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  align-self: flex-start;\n}\n\n.footer-cta:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(186, 122, 39, 0.4);\n}\n\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 20px;\n  text-align: center;\n}\n\n.footer-bottom p {\n  color: #999;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .footer {\n    padding: 40px 15px 20px;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n\n  .footer-section {\n    text-align: center;\n    align-items: center;\n  }\n\n  .footer-links li {\n    text-align: center;\n  }\n\n  .footer-links li:hover {\n    padding-left: 0;\n  }\n\n  .footer-cta {\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
